import { useLocation, useParams, useSearchParams } from "react-router";

import type { RouteInfo } from "@/shared/types/route";

export function useRouteInfo() {
    const location = useLocation();
    const params = useParams();
    const [searchParams] = useSearchParams();

    // 构建路由信息对象
    const routeInfo: RouteInfo = {
        pathname: location.pathname,
        search: location.search,
        format: searchParams.get("format"),
        folderId: params.folderId,
        tagId: params.tagId,
    };

    return routeInfo;
}
